require("./vendor/slick.min");
require("./vendor/masonry.pkgd.min");
require("./vendor/imagesloaded.pkgd.min");
// require('./vendor/bootstrap.min');

require("./app/config");
require("./app/helpers");
require("./app/global");

// Photo Block Slider
var $el = $(".photo-slider");
$el.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: false,
});

var slideCount = $(".slick-counter");
var slickSlide = $(".bianchi-slider");

slickSlide.on(
    "init reInit afterChange",
    function (event, slick, currentSlide, nextSlide) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        $(this)
            .find(".slick-counter")
            .html(i + " / " + slick.slideCount);
    }
);

var $grid = $(".grid").masonry({
    initLayout: false,
    itemSelector: ".grid-item",
    // use element for option
    columnWidth: ".grid-sizer",
    percentPosition: true,
});
$grid.on("layoutComplete", function () {
    $(".loading").hide();
    setTimeout(function () {
        $grid.removeClass("is-loading");
    }, 250); // slow this down to smooth the transition from loading to loaded state
});
$grid.imagesLoaded(function () {
    $grid.masonry();
});

/*
Album lightbox/carousel
Went custom here to avoid problems with responsive image sizing/slider weirdness using slick
*/
const $lb = $(".album-lightbox");
const $lbPrev = $lb.find(".prev");
const $lbNext = $lb.find(".next");
// click next
$lbNext.on("click", function (e) {
    e.preventDefault();
    let $current = $lb.find(".active");
    let i = $current.data("index") * 1 + 1;
    let $next = $lb.find(`.item[data-index="${i}"]`);
    $current.removeClass("active moving swipedRight swipedLeft");
    if (!$next.length) {
        $next = $lb.find(`.item`).first();
    }
    $next.addClass("active");
});
// click previous
$lbPrev.on("click", function (e) {
    e.preventDefault();
    let $current = $lb.find(".active");
    let i = $current.data("index") * 1 - 1;
    let $next = $lb.find(`.item[data-index="${i}"]`);
    $current.removeClass("active moving swipedRight swipedLeft");
    if (!$next.length) {
        $next = $lb.find(`.item`).last();
    }
    $next.addClass("active");
});
// closing (also added to the escape key in global.js)
$lb.find(".modal-close").on("click", function (e) {
    e.preventDefault();
    $lb.removeClass("shown");
});
// opening
$(".album-photo").on("click", function (e) {
    e.preventDefault();
    $lb.find(".item").removeClass("active");
    $lb.find($lb.find(`.item[data-index="${$(this).data("index")}"]`)).addClass(
        "active"
    );
    $lb.addClass("shown");
});

// basic swipe support
var startX = 0;
var dist = 0;
var scaling = false;
const threshhold = 100;
const timeout = 500;
// capture the starting point
$lb.find(".item").on("touchstart", function (e) {
    scaling = e.touches.length > 1;
    if (!scaling) {
        var touchobj = e.changedTouches[0];
        startX = parseInt(touchobj.clientX);
        e.preventDefault();
    }
});
// how far did we swipe
$lb.find(".item").on("touchmove", function (e) {
    scaling = e.touches.length > 1;
    if (!scaling) {
        var touchobj = e.changedTouches[0];
        dist = parseInt(touchobj.clientX) - startX;
        $(this).css("transform", `translateX(${dist}px)`);
        e.preventDefault();
    }
});
// do something when we're done swiping
$lb.find(".item").on("touchend", function (e) {
    if (scaling) {
        scaling = false;
        return;
    }
    if (dist < 0) {
        // swiped left, show the next photo
        if (Math.abs(dist) > threshhold) {
            // .moving smooths the transitions when we're not touching anymore
            // without it, we get 1-to-1 movement, which is what we want during the touch events
            $(this).removeAttr("style").addClass("moving swipedLeft");
            window.setTimeout(() => {
                $lbNext.click();
            }, timeout);
        } else {
            // not enough movement, re-center
            $(this).removeAttr("style").addClass("moving");
            window.setTimeout(() => {
                $(this).removeClass("moving");
            }, timeout);
        }
    } else {
        // swiped right, show the previous photo
        if (dist > threshhold) {
            $(this).removeAttr("style").addClass("moving swipedRight");
            window.setTimeout(() => {
                $lbPrev.click();
            }, timeout);
        } else {
            // not enough movement, re-center
            $(this).removeAttr("style").addClass("moving");
            window.setTimeout(() => {
                $(this).removeClass("moving");
            }, timeout);
        }
    }
    e.preventDefault();
});

$('.filters [type="checkbox"]').on("change", function () {
    $(".filters .btn").show();
});
